import AbstractMediator from "../../../core/ui/AbstractMediator";

export default class EmailDraftSendComponentMediator extends AbstractMediator {

    constructor(target, dispatcher) {
        super(target, dispatcher);

        this._dispatcher = dispatcher;
    }
}